import { Badge } from '@mevaser/ui'

/**
 * Renders one per-unit attribute for display. `true` reads as a bare
 * checked-off fact ("filtered"); an explicit `false` is still shown, not
 * hidden, since a tech deliberately recording "not filtered" is meaningful —
 * `key: no` stays unambiguous even for a key that already reads like a
 * negative ("no text").
 */
export function formatUnitAttribute(key: string, value: string | number | boolean): string {
  if (value === true) return key
  if (value === false) return `${key}: no`
  return `${key}: ${value}`
}

/** Every recorded per-unit attribute, as small badges — used anywhere a
 *  device's record is shown, so staff see this handset's actual checked-off
 *  status rather than just its product template. */
export function UnitAttributeBadges({
  attributes,
}: {
  attributes: Record<string, string | number | boolean>
}) {
  const entries = Object.entries(attributes).sort(([a], [b]) => a.localeCompare(b))
  if (entries.length === 0) return null
  return (
    <span className="mt-1 flex flex-wrap gap-1">
      {entries.map(([key, value]) => (
        <Badge key={key} tone="neutral">
          {formatUnitAttribute(key, value)}
        </Badge>
      ))}
    </span>
  )
}
